<template>
<div v-if="showIcon" class="select-ctrl-icon-group">
  <div title="全选" class="icon primary" @click="onSelectAllBtnClick"><i class="el-icon-finished"></i></div>
  <div title="反选" class="icon warning" @click="onInvertSelectBtnClick"><i class="el-icon-refresh-left"></i></div>
  <div title="清空" class="icon danger" @click="onClearBtnClick"><i class="el-icon-delete"></i></div>
</div>

<div v-else class="select-ctrl-group">
  <el-button type="primary" @click="onSelectAllBtnClick">全选</el-button>
  <el-button type="warning" @click="onInvertSelectBtnClick">反选</el-button>
  <el-button type="danger" @click="onClearBtnClick">清空</el-button>
</div>
</template>

<script>
export default {
  name: 'SelectCtrlGroup',
  props: {
    ids: {
      required: true,
      type: Array
    },
    options: {
      required: true,
      type: Array
    },
    idProp: {
      type: String,
      default: 'id'
    },
    showIcon: {
      type: Boolean
    }
  },
  methods: {
    onSelectAllBtnClick () {
      let {ids, idProp} = this
      ids.splice(0, ids.length, ...this.options.map(option => option[idProp]))
      this.$emit('change', ids)
    },
    onInvertSelectBtnClick () {
      let {ids, idProp} = this
      let selectedMap = ids.reduce((map, id) => {
        map[id] = true
        return map
      }, {})

      ids.splice(0, ids.length, ...this.options.reduce((ids, option) => {
        let id = option[idProp]

        if (!selectedMap[id]) {
          ids.push(id)
        }

        return ids
      }, []))

      this.$emit('change', ids)
    },
    onClearBtnClick () {
      let {ids} = this
      ids.splice(0, ids.length)
      this.$emit('change', ids)
    }
  }
}
</script>

<style lang="scss">
.select-ctrl-group {
  display: grid;
  grid-template-columns: repeat(3, 50px);
  grid-column-gap: 5px;
  justify-content: var(--select-ctrl-group-justify-content, flex-end);
  padding: var(--select-ctrl-group-padding, 5px 10px);

  > * {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 26px !important;
  }
}

.select-ctrl-icon-group {
  display: grid;
  grid-template-columns: repeat(3, 1.5em);
  justify-content: var(--select-ctrl-group-justify-content, flex-end);
  align-items: center;
  height: 100%;
  padding: var(--select-ctrl-group-padding, 0);

  > .icon {
    text-align: center;
    cursor: pointer;

    &:hover {
      &.primary {
        color: #409eff;
      }

      &.warning {
        color: #e6a23c;
      }

      &.danger {
        color: #f56c6c;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SelectCtrlGroup/index.vue